import { render, staticRenderFns } from "./InvestRow.vue?vue&type=template&id=e0620076&scoped=true&"
import script from "./InvestRow.vue?vue&type=script&lang=js&"
export * from "./InvestRow.vue?vue&type=script&lang=js&"
import style0 from "./InvestRow.vue?vue&type=style&index=0&id=e0620076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0620076",
  null
  
)

export default component.exports